module.exports = __webpack_public_path__ + "fonts/CRC55.b6c5baa1.eot";